module.exports = __webpack_public_path__ + "static/assets/e64ac5c53cdf42af6f44032601c77b5d.png";